// extracted by mini-css-extract-plugin
export default {"one":"Menu_one__eZZgy","MenuC":"Menu_MenuC__eyvRR","card":"Menu_card__CjzTy","custom-file-label":"Menu_custom-file-label__AzyHr"};